import { baseUrl } from '../../utils/utils';

export class CTIAuthentication extends HTMLElement {
    private template: HTMLTemplateElement;

    constructor() {
        super();
        this.template = document.createElement('template');
        this.attachShadow({ mode: 'open' });
        this.template.innerHTML = '<spinner-element></spinner-element>';
    }

    connectedCallback() {
        this.shadowRoot.appendChild(this.template.content.cloneNode(true));

        if (window.opener) {
            const searchParams = new URLSearchParams(window.location.search);
            const hashParams = new URLSearchParams(window.location.hash);

            // We need to check for code url parameter to enable Bullhorn login in the bullhorn plugin
            if (searchParams.has('code')) {
                const message = { code: searchParams.get('code') };
                window.opener.postMessage(message, baseUrl());
            }

            // We need to check for access_token hash parameter to enable ServiceNow login in the servicenow plugin
            if (hashParams.has('#access_token')) {
                const message = { token: hashParams.get('#access_token') };
                window.opener.postMessage(message, baseUrl());
            }
        }
    }
}

window.customElements.define('cti-auth-component', CTIAuthentication);
